const ContactItems = [
  {
    id: 1,
    icon: 'map-marker-alt',
    text: ['Հայաստան,Երեվան Փ. Աբովյան 54', 'Армения,Ереван ул. Абовяна 54', '54 Abovyan str. Yerevan, Armenia']
  },
  {
    id: 2,
    icon: 'phone',
    text: `<p> +37494060890</p><p> +37491538883</p>`
  },
  {
    id: 3,
    icon: 'envelope',
    text: `g_amirbekyan@yahoo.com`
  }
];
export default function(state = ContactItems, action) {
  return state;
}
